import { makeStyles } from "@material-ui/core";

export default makeStyles(
  (theme) => ({
    root: {
      backgroundColor: theme.palette.common.white,
      color: theme.palette.primary.light,
    },
    toolbar: {
      height: theme.sizes.mobile.header.height,
      [theme.breakpoints.up("tablet")]: {
        height: theme.sizes.desktop.header.height,
      },
      display: "block",
    },
    searchBar: {
      position: "relative",
      alignSelf: "right",
    },
  }),
  { name: "UserLayoutHeader" },
);
